import { css, type Theme } from "@emotion/react";

import { animations } from "@styles";

export const checkbox = {
  base: css`
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    justify-content: flex-start;
    gap: 0.5rem;
  `,
  isFullWidth: css`
    width: 100%;
  `,
  disabled: css`
    cursor: not-allowed;
    user-select: none;
  `,
};

export const checkboxInput = (theme: Theme) => css`
  position: absolute;
  left: -9999px;

  & + div {
    ${animations.transition()};
    border-color: ${theme.input.borderEmphasized};
  }

  & + div > svg {
    color: ${theme.input.backgroundInformation};
  }

  &:checked + div,
  &:indeterminate + div {
    > svg {
      opacity: 1;
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
  &:checked + div,
  &:indeterminate + div {
    background-color: ${theme.input.borderActive};
    border-color: ${theme.input.borderActive};
  }
  &:hover + div {
    border-color: ${theme.input.borderEmphasizedHover};
  }
  &:focus-visible + div,
  &:active + div {
    border-color: ${theme.input.borderActive};
    border-width: 2px;
    transition: none;
  }
  // Label text
  &:active + div + div {
    color: ${theme.text.body};
  }
  &:hover + div + div {
    color: ${theme.text.emphasis};
  }
  &:focus-visible + div + div {
    color: ${theme.input.borderActive};
  }
  &[disabled] {
    &:hover + div + div {
      color: ${theme.disabled.text};
    }
    &:focus + div,
    &:active + div,
    &:hover + div {
      box-shadow: none;
    }
  }
`;

export const iconContainer = {
  base: (theme: Theme) => css`
    ${animations.transition()};
    cursor: pointer;
    width: 1rem;
    height: 1rem;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border: 1px solid ${theme.input.borderEmphasized};
  `,
  disabled: (theme: Theme) => css`
    cursor: not-allowed;
    &&& {
      border-color: ${theme.disabled.border};
      background-color: ${theme.disabled.inputBackground};
    }
  `,
};

export const checkboxContent = {
  base: (theme: Theme) => css`
    ${animations.transition()};

    &:active {
      color: ${theme.input.borderEmphasizedHover};
    }
  `,
  disabled: (theme: Theme) => css`
    cursor: not-allowed;
    color: ${theme.disabled.text};
  `,
};

export const icon = {
  base: (theme: Theme) => css`
    ${animations.transition()};
    color: ${theme.input.backgroundInformation};
    height: 0.75rem;
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  `,
  disabled: (theme: Theme) => css`
    cursor: not-allowed;
    &&& {
      color: ${theme.disabled.inputLabelText};
    }
  `,
};
